import React, { useState, useEffect } from 'react';
import { 
  Bot,
  ChevronRight,
  Share,
  User,
  Menu,
  ThumbsUp,
  Repeat,
  MessageSquare,
  Plus,
  Linkedin,
  CheckCircle,
  ExternalLink,
  Building2
} from 'lucide-react';
import Sidebar from './Sidebar';
import Header from './Header';
import { useDashboard } from './Dashboardcontext';
import LinkedInConnectionModal from './LinkedInConnectionModal';

// Social Media Logo Components (keep these as-is)
const LinkedInLogo = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5 lg:w-6 lg:h-6" fill="#0A66C2">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const YouTubeLogo = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5 lg:w-6 lg:h-6" fill="#FF0000">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  </svg>
);

const InstagramLogo = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5 lg:w-6 lg:h-6">
    <defs>
      <linearGradient id="instagram-gradient" x1="0%" y1="100%" x2="100%" y2="0%">
        <stop offset="0%" style={{stopColor: '#FED373'}} />
        <stop offset="15%" style={{stopColor: '#F15245'}} />
        <stop offset="30%" style={{stopColor: '#D92E7F'}} />
        <stop offset="50%" style={{stopColor: '#9B36B7'}} />
        <stop offset="85%" style={{stopColor: '#515ECF'}} />
      </linearGradient>
    </defs>
    <path fill="url(#instagram-gradient)" d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/>
  </svg>
);

const TikTokLogo = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5 lg:w-6 lg:h-6" fill="currentColor">
    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
  </svg>
);

const XLogo = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5 lg:w-6 lg:h-6" fill="currentColor">
    <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"/>
  </svg>
);

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showLinkedInModal, setShowLinkedInModal] = useState(false);

  // ✅ USE CONTEXT
  const { dashboardData, loading, error, fetchDashboardData, refreshDashboard } = useDashboard();

  // ✅ SAFETY FETCH ON MOUNT
  useEffect(() => {
    console.log('📍 Dashboard component mounted');
    
    if (!dashboardData && !loading) {
      console.log('⚠️ No data on mount - triggering fetch');
      fetchDashboardData(false);
    }
  }, []);

  console.log('📍 Dashboard component render');
  console.log('📍 Has data?', !!dashboardData);
  console.log('📍 Loading?', loading);

  const handleLinkedInConnected = () => {
    setShowLinkedInModal(false);
    refreshDashboard();
  };

  const LatestPosts = () => {
    const latestPost = dashboardData?.latestPost;
    
    // ✅ GUEST MODE CHECK
    if (dashboardData?.isGuestMode || !latestPost) {
      return (
        <div className="bg-white rounded-lg p-4 lg:p-6 shadow-sm">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold">Latest Posts</h2>
          </div>
          
          <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-lg p-8 text-center border-2 border-dashed border-blue-200">
            <Linkedin className="w-12 h-12 mx-auto mb-4 text-blue-600" />
            <h3 className="font-semibold text-gray-800 mb-2">Connect LinkedIn to See Your Posts</h3>
            <p className="text-sm text-gray-600 mb-4">
              Once connected, your latest posts and engagement metrics will appear here
            </p>
            <button 
              onClick={() => setShowLinkedInModal(true)}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 inline-flex items-center"
            >
              <Linkedin className="w-4 h-4 mr-2" />
              Connect Now
            </button>
          </div>
        </div>
      );
    }
    
    return (
      <div className="bg-white rounded-lg p-4 lg:p-6 shadow-sm">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold">Latest Posts</h2>
          <button className="text-gray-400">×</button>
        </div>
        
        <div className="bg-gray-50 rounded-lg p-3 lg:p-4 mb-4">
          {latestPost?.media_url ? (
            <div className="w-full h-32 lg:h-48 rounded-lg mb-3 lg:mb-4 overflow-hidden">
              <img 
                src={latestPost.media_url} 
                alt="Latest post" 
                className="w-full h-full object-cover"
              />
            </div>
          ) : (
            <div className="w-full h-32 lg:h-48 bg-gradient-to-r from-blue-100 to-blue-200 rounded-lg mb-3 lg:mb-4 flex items-center justify-center">
              <div className="text-center p-4">
                <div className="text-blue-600 font-semibold text-sm lg:text-base">
                  {latestPost?.content?.substring(0, 100) || 'No recent posts'}...
                </div>
              </div>
            </div>
          )}
          
          <div className="flex items-center justify-between text-sm text-gray-500">
            <div className="flex items-center space-x-3 lg:space-x-4">
              <span className="flex items-center">
                <ThumbsUp className="w-4 h-4 mr-1" />
                {latestPost?.engagement?.likes || 0}
              </span>
              <span className="flex items-center">
                <Repeat className="w-4 h-4 mr-1" />
                {latestPost?.engagement?.reposts || 0}
              </span>
              <span className="flex items-center">
                <MessageSquare className="w-4 h-4 mr-1" />
                {latestPost?.engagement?.comments || 0}
              </span>
            </div>
          </div>
        </div>

        <div className="space-y-2 text-sm">
          <div className="flex justify-between">
            <span>Likes</span>
            <span>{latestPost?.stats?.likes || 0}</span>
          </div>
          <div className="flex justify-between">
            <span>Repost</span>
            <span>{latestPost?.stats?.repost || 0}</span>
          </div>
          <div className="flex justify-between">
            <span>Comments</span>
            <span>{latestPost?.stats?.comments || 0}</span>
          </div>
          <div className="flex justify-between">
            <span>Digimark Score</span>
            <span className="text-blue-600 font-medium">{latestPost?.digimarkScore || '0%'}</span>
          </div>
        </div>

        <button 
          onClick={() => window.location.href = '/scheduled-posts'}
          className="w-full mt-4 py-2 bg-gray-100 text-gray-600 rounded-lg hover:bg-gray-200 text-sm"
        >
          Show all posts
        </button>
      </div>
    );
  };

  const AnalyticsSection = () => {
    const analytics = dashboardData?.analytics;
    
    // ✅ GUEST MODE CHECK
    if (dashboardData?.isGuestMode) {
      return (
        <div className="bg-white rounded-lg p-4 lg:p-6 shadow-sm">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold">Analytics</h2>
          </div>

          <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg p-8 text-center border-2 border-dashed border-gray-200">
            <div className="text-gray-400 mb-4">
              <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
            <h3 className="font-semibold text-gray-800 mb-2">No Analytics Available</h3>
            <p className="text-sm text-gray-600">
              Connect your LinkedIn to start tracking your performance
            </p>
          </div>
        </div>
      );
    }
    
    return (
      <div className="bg-white rounded-lg p-4 lg:p-6 shadow-sm">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold">Analytics</h2>
          <button className="text-gray-400">×</button>
        </div>

        <div className="mb-6">
          <h3 className="font-medium mb-2">Current Followers</h3>
          <div className="text-2xl font-bold">
            {analytics?.currentFollowers?.count?.toLocaleString() || '0'}
          </div>
          <div className="text-sm text-green-600">
            {analytics?.currentFollowers?.growth || '+0 in last 30 days'}
          </div>
        </div>

        <div className="mb-6">
          <h3 className="font-medium mb-3">Summary</h3>
          <div className="text-sm text-gray-500 mb-2">
            {analytics?.summary?.period || 'In last 7 days'}
          </div>
          <div className="space-y-2">
            <div className="flex justify-between">
              <span>Page Visits</span>
              <span>{analytics?.summary?.pageVisits || 0}</span>
            </div>
            <div className="flex justify-between">
              <span>Total Likes</span>
              <span>{analytics?.summary?.totalLikes || 0}</span>
            </div>
          </div>
        </div>

        <div className="mb-6">
          <h3 className="font-medium mb-3">Top Posts</h3>
          <div className="text-sm text-gray-500 mb-2">
            {analytics?.topPosts?.period || 'In last 1 month'}
          </div>
          <div className="space-y-2 text-sm">
            {analytics?.topPosts?.posts && analytics.topPosts.posts.length > 0 ? (
              analytics.topPosts.posts.map((post, index) => (
                <div key={index} className="flex justify-between">
                  <span className="truncate pr-2">{post.content}</span>
                  <span className="text-blue-600 flex-shrink-0 font-medium">{post.score}</span>
                </div>
              ))
            ) : (
              <div className="text-gray-400 text-center py-2">No top posts yet</div>
            )}
          </div>
        </div>

        <button 
          onClick={() => window.location.href = '/analytics'}
          className="w-full py-2 bg-gray-700 text-white rounded-lg hover:bg-gray-800 text-sm"
        >
          Go to Analytics
        </button>

        <div className="mt-6">
          <h3 className="font-medium mb-3">Track performance</h3>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span>Engagement rate</span>
              <span className="font-medium">{analytics?.trackPerformance?.engagementRate || '0%'}</span>
            </div>
            <div className="flex justify-between">
              <span>Target vs. Actual</span>
              <span className="font-medium">{analytics?.trackPerformance?.targetVsActual || '0%'}</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const YourApps = () => {
    const upcomingPosts = dashboardData?.upcomingPosts || [];
    
    // ✅ GET SELECTED ACCOUNT FROM localStorage (set by Header.js)
    const linkedInAccountId = localStorage.getItem('selectedLinkedInAccountId');
    const accountType = localStorage.getItem('selectedAccountType');
    const accountUsername = localStorage.getItem('selectedLinkedInUsername');
    
    const selectedAccount = linkedInAccountId ? {
      linkedin_account_id: parseInt(linkedInAccountId),
      account_type: accountType || 'personal',
       profile_name: accountUsername || 'LinkedIn Account'
    } : null;
    
    return (
      <div className="bg-white rounded-lg p-4 lg:p-6 shadow-sm">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold">Your Apps</h2>
          <button className="text-gray-400">×</button>
        </div>

        {/* LinkedIn Connection Status */}
        {selectedAccount ? (
          <div className="mb-6">
            <h3 className="font-medium mb-3">Active LinkedIn Account</h3>
            <div className="bg-green-50 border-2 border-green-200 rounded-lg p-4">
              <div className="flex items-center">
                {selectedAccount.account_type === 'company' ? (
                  <Building2 className="w-10 h-10 text-blue-600 mr-3" />
                ) : (
                  <Linkedin className="w-10 h-10 text-blue-600 mr-3" />
                )}
                <div className="flex-1">
                  <div className="font-semibold text-gray-900">
                    {selectedAccount.profile_name}
                  </div>
                  <div className="text-xs text-gray-600 capitalize">
                    {selectedAccount.account_type} Account
                  </div>
                </div>
                <CheckCircle className="w-5 h-5 text-green-500" />
              </div>
            </div>
          </div>
        ) : (
          <div className="mb-6 bg-blue-50 border-2 border-blue-200 rounded-lg p-4">
            <p className="text-sm text-blue-800 mb-3">
              Connect your LinkedIn account to get started
            </p>
            <button
              onClick={() => setShowLinkedInModal(true)}
              className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              <Linkedin className="w-4 h-4 inline mr-2" />
              Connect LinkedIn
            </button>
          </div>
        )}

        {/* More Apps - Coming Soon */}
        <div className="mb-6">
          <h3 className="font-medium mb-3">More Apps</h3>
          <div className="space-y-2">
            {[
              { name: 'Instagram', logo: <InstagramLogo /> },
              { name: 'TikTok', logo: <TikTokLogo /> },
              { name: 'X (Twitter)', logo: <XLogo /> }
            ].map((app, index) => (
              <div key={index} className="flex items-center justify-between py-2 px-3 bg-gray-50 rounded-lg opacity-60">
                <div className="flex items-center min-w-0">
                  <div className="flex-shrink-0 mr-3 text-gray-700">
                    {app.logo}
                  </div>
                  <span className="text-sm truncate">{app.name}</span>
                </div>
                <span className="text-xs text-gray-500">Coming Soon</span>
              </div>
            ))}
          </div>
        </div>

        {/* Upcoming Posts */}
        <div>
          <h3 className="font-medium mb-3">Upcoming Post</h3>
          <div className="space-y-3">
            {upcomingPosts.length > 0 ? (
              upcomingPosts.map((post, index) => (
                <div key={index} className="flex items-center py-2">
                  <div className="w-2 h-2 lg:w-2 lg:h-2 bg-blue-400 rounded mr-3 flex-shrink-0"></div>
                  <div className="flex-1 min-w-0 cursor-pointer" onClick={() => window.location.href = '/scheduled-posts'}>
                    <div className="text-sm font-medium truncate">{post.title}</div>
                  </div>
                  <div className="text-xs text-gray-500 flex-shrink-0 ml-2">{post.date}</div>
                </div>
              ))
            ) : (
              <div className="text-gray-400 text-sm text-center py-4">
                {selectedAccount
                  ? 'No upcoming posts scheduled' 
                  : 'Connect LinkedIn to start scheduling posts'}
              </div>
            )}
          </div>
        </div>

        {/* Getting Started Guide for users without account */}
        {!selectedAccount && (
          <div className="mt-6 bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg border border-blue-200 p-4">
            <h4 className="font-semibold text-gray-800 mb-2 text-sm">🚀 Quick Start</h4>
            <ol className="space-y-2 text-xs text-gray-700">
              <li className="flex items-start">
                <span className="font-bold mr-2">1.</span>
                <span>Connect your LinkedIn account above</span>
              </li>
              <li className="flex items-start">
                <span className="font-bold mr-2">2.</span>
                <span>Create AI-powered posts</span>
              </li>
              <li className="flex items-start">
                <span className="font-bold mr-2">3.</span>
                <span>Schedule & publish automatically</span>
              </li>
            </ol>
          </div>
        )}
      </div>
    );
  };

  const renderContent = () => {
    if (loading) {
      return (
        <div className="flex items-center justify-center py-20">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-600 border-t-transparent mx-auto mb-4"></div>
            <p className="text-gray-600">Loading dashboard...</p>
          </div>
        </div>
      );
    }

    if (error) {
      return (
        <div className="bg-white rounded-lg p-8 shadow-sm text-center">
          <div className="text-red-500 mb-4">
            <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 className="text-xl font-semibold mb-2">Failed to Load Dashboard</h2>
          <p className="text-gray-600 mb-4">{error}</p>
          <button 
            onClick={refreshDashboard}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Retry
          </button>
        </div>
      );
    }

    return (
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6">
        <LatestPosts />
        <AnalyticsSection />
        <YourApps />
      </div>
    );
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />
      <div className="flex-1 flex flex-col min-w-0 lg:ml-64">
        <div className="flex-1 p-4 lg:p-8 overflow-y-auto">
          <Header />
          {renderContent()}
        </div>
      </div>

      {/* LinkedIn Connection Modal */}
      {showLinkedInModal && (
        <LinkedInConnectionModal
          isOpen={showLinkedInModal}
          onClose={() => setShowLinkedInModal(false)}
          onSuccess={handleLinkedInConnected}
        />
      )}
    </div>
  );
};

export default Dashboard;